module.exports = __webpack_public_path__ + "static/media/chatNew.359e231d.svg";